import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as workflowStatusTypes from './workflowStatusTypes';

const byId = handleActions(
  {
    [workflowStatusTypes.WORKFLOW_STATUS_LIST.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload.entities.workflowStatus,
    }),
  },
  {},
);

const allIds = handleActions(
  {
    [workflowStatusTypes.WORKFLOW_STATUS_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
